module.exports = __webpack_public_path__ + "assets/img/images-links-2.962b9e7b.jpg";